import { render, staticRenderFns } from "./tab-header-title.vue?vue&type=template&id=7ad8d123&scoped=true&"
import script from "./tab-header-title.vue?vue&type=script&lang=js&"
export * from "./tab-header-title.vue?vue&type=script&lang=js&"
import style0 from "./tab-header-title.vue?vue&type=style&index=0&id=7ad8d123&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@5.2.7_vue-template-compiler@2.6.11_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad8d123",
  null
  
)

export default component.exports